import { defineMessages } from 'react-intl';

const messages: {
	loadingSpacesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	loadingSpacesLabel: {
		id: 'rovo-for-you.my-spaces-skeleton.loading-spaces-label',
		defaultMessage: 'Loading spaces',
		description: 'Accessible label for the my spaces list skeleton loading state',
	},
});

export default messages;
